import { create } from "zustand";
import { persist } from "zustand/middleware";
import { UserState } from "./types";

/**
 * User store for managing user state
 * Persists user data in localStorage
 */
const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: {} as UserState["user"],
      setUser: (user) => set({ user }),
      resetUser: () => set({ user: {} as UserState["user"] }),
    }),
    {
      name: "user-store",
    }
  )
);

export default useUserStore;
